import { lazy } from "react"

export const AllLeaveRequest = lazy(() => import("./allLeaveRequest/AllLeaveRequest"))
export const LeaveBalance = lazy(() => import("./leaveBalance/LeaveBalance"))
export const ApplyForLeave = lazy(() => import("./applyForLeave/ApplyForLeave"))
export const ApprovedDeclined = lazy(() => import("./allLeaveRequest/approvedDeclined/ApprovedDeclined"))
export const GenerateLeave = lazy(() => import("./generateLeave/GenerateLeave"))
export { default as LeavesSliceReducer } from "./store/LeavesSlice"